import { render } from "./SideNavBar.vue?vue&type=template&id=8b6855b4&scoped=true&ts=true"
import script from "./SideNavBar.vue?vue&type=script&lang=ts"
export * from "./SideNavBar.vue?vue&type=script&lang=ts"

import "./SideNavBar.vue?vue&type=style&index=0&id=8b6855b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6855b4"]])

export default __exports__